import { render, staticRenderFns } from "./LoginOtpPage.vue?vue&type=template&id=351834ba&scoped=true&"
import script from "./LoginOtpPage.vue?vue&type=script&lang=js&"
export * from "./LoginOtpPage.vue?vue&type=script&lang=js&"
import style0 from "./LoginOtpPage.vue?vue&type=style&index=0&id=351834ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351834ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAppBar,VBtn,VCol,VImg,VLayout,VRow,VSpacer,VTextField})
